import { useLocation } from 'react-router-dom';

/** اجبار remount هنگام تعویض مسیر — رفع باگ ماندن صفحه ویزارد پس از ناوبری */
export default function KeyedRoute({ children }) {
  const { pathname } = useLocation();
  return (
    <div key={pathname} className="contents">
      {children}
    </div>
  );
}
